import { toast } from 'react-toastify';

export const showSuccess = (message) => {
  toast.success(message, {
    autoClose: 1500,
  });
};
